import { createValidatorConverter } from 'src/services/database/utils';
import { FlowInstanceDto } from 'src/services/database/FlowInstances/dto/flowInstance.dto';

export const FlowInstanceConverter = createValidatorConverter(FlowInstanceDto, {
  useFirestoreTimestamp: true,
});
